"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Interaction = void 0;
var OnConversed_1 = require("./OnConversed");
var Interaction = /** @class */ (function (_super) {
    __extends(Interaction, _super);
    function Interaction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Interaction";
        _this.onConversed = function (config) { return _this.push(function (registry) {
            var entity = new OnConversed_1.OnConversed();
            config(entity);
            return "onConversed { " + entity.render(registry) + " }";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Interaction;
}(Array));
exports.Interaction = Interaction;
//# sourceMappingURL=Interaction.js.map